import { generate as componentGenerate } from './componentUtils';

export function getDefaultOptions(store) {
    return {
        getDeviceCharacteristics() {
            return _.get(store.getState(), 'core.deviceCharacteristics', {});
        },
        getState() {
            return store.getState()
        },
        dispatch: store.dispatch,
        runSaga: store.runSaga
    };
}

export function generate(config, store, overrides) {
    return componentGenerate(config, store, overrides, getDefaultOptions(store));
}
